import React, { Component } from "react";
import { sendGA4Event } from "../utils/tracking";
import { Nav, NavItem, FormGroup, ControlLabel } from "react-bootstrap";
import axios from "axios";
import LoaderPanel from "../components/LoaderPanel";
import TitlePage from "../components/TitlePage";
import withLoadSave from "../components/LoadSave";
import MenuNavbar from "../components/MenuNavbar";
import LoaderButton from "../components/LoaderButton";
import { EDTabs } from "../components/EDDOM";
import { FormControlLabel, CheckboxLabel } from "../components/FormControls";
import getvalue from "../utils/getvalue";
import notify from "../utils/notify";

class IntegrateWebHooks extends Component {
  switchView = url => {
    this.props.history.push(url);
  }

  handleChange = event => {
    this.props.update({[event.target.id]: {$set: getvalue(event)}});
  }
  handleEventChange = event => {
    this.props.update({events: {[event.target.id]: {$set: getvalue(event)}}});
  }

  handleSave = async () => {
    await this.props.save();
    notify.show('Webhook Configuration Saved', 'success');
  }

  render() {
    return (
      <MenuNavbar {...this.props}>
        <TitlePage title="Event Web Hooks"
          tabs={
            <EDTabs>
              <Nav className="nav-tabs space15" activeKey="3">
                <NavItem eventKey="1" onClick={this.switchView.bind(null, '/integrate')}>Sending API</NavItem>
                <NavItem eventKey="2" onClick={this.switchView.bind(null, '/integrate/smtp')}>SMTP Relay</NavItem>
                <NavItem eventKey="3" disabled>Event Web Hooks</NavItem>
              </Nav>
            </EDTabs>
          }
        />
        <LoaderPanel isLoading={this.props.isLoading}>
          <div className="Login">
            <div className="api-box">
              <p>Entering a URL here will cause the system to send an HTTP POST each time an event occurs such as a bounce, open, or click.</p>
              <p>For a full list of event types and the data associated with each event, see the Web Hooks section in the <a href="/api/doc" target="_blank">full documentation</a>.</p>
              <FormControlLabel
                id="webhook"
                obj={this.props.data}
                onChange={this.handleChange}
                label="Web Hook URL"
              />
              <FormGroup className="space20">
                <ControlLabel>Events to Send</ControlLabel>
                <div className="form-inline">
                  <CheckboxLabel
                    id="open"
                    inline
                    obj={this.props.data.events}
                    onChange={this.handleEventChange}
                    label="Open"
                    style={{marginRight: '14px'}}
                  />
                  <CheckboxLabel
                    id="click"
                    inline
                    obj={this.props.data.events}
                    onChange={this.handleEventChange}
                    label="Click"
                    style={{marginRight: '14px'}}
                  />
                  <CheckboxLabel
                    id="bounce"
                    inline
                    obj={this.props.data.events}
                    onChange={this.handleEventChange}
                    label="Bounce"
                    style={{marginRight: '14px'}}
                  />
                  <CheckboxLabel
                    id="complaint"
                    inline
                    obj={this.props.data.events}
                    onChange={this.handleEventChange}
                    label="Complaint"
                    style={{marginRight: '14px'}}
                  />
                  <CheckboxLabel
                    id="unsub"
                    inline
                    obj={this.props.data.events}
                    onChange={this.handleEventChange}
                    label="Unsubscribe"
                  />
                </div>
              </FormGroup>
              <div className="text-center">
                <LoaderButton
                  bsSize="large"
                  className="green space10"
                  type="submit"
                  text="Save"
                  loadingText="Saving..."
                  onClick={() => {
                    sendGA4Event('Event Web Hooks', 'Web Hooks', 'Created Event Web Hooks');
                    return this.handleSave();
                  }}
                />
              </div>
            </div>
          </div>
        </LoaderPanel>
      </MenuNavbar>
    );
  }
}

export default withLoadSave({
  extend: IntegrateWebHooks,
  initial: [],
  get: async () => (await axios.get('/api/webhooks')).data,
  patch: async ({data}) => (await axios.patch('/api/webhooks', data)),
});



// WEBPACK FOOTER //
// ./src/containers/IntegrateWebHooks.js